import { IsDefined, IsString } from 'class-validator';

export class BillingGetTokenResponse {
    @IsDefined()
    @IsString()
    public token: string;

    constructor(data?: Partial<BillingGetTokenResponse>) {
        this.token = data?.token;
    }
}
